
  import {Component, Model, Vue, Watch} from "vue-property-decorator";
  import {AuditFilterType} from "@/api/appService";
  import {SelectListItem} from "@/core/common-type-definitions";

  @Component({name:'AuditFilterSelect'})
  export default class AuditFilterSelect extends Vue{

    @Model('change',{default:undefined})readonly filterType?:string;


    private value?:string = '';

    created(){
      this.value = this.filterType;
    }

    get items():SelectListItem<string>[]{
      const types = [] as SelectListItem<string>[];
      types.push({value:AuditFilterType.NotStart,label:'未开始'});
      types.push({value:AuditFilterType.Auditing,label:'审核中'});
      types.push({value:AuditFilterType.Passed.toString(),label:'已审核通过'});
      types.push({value:AuditFilterType.Rejected.toString(),label:'未通过'});

      return types;
    }

    @Watch('filterType')
    onFilterTypeChange(newValue?:string){
      if(newValue !== this.value){
        this.value = newValue;
      }

    }

    handleValueChange(newValue?:string){
      this.$emit('change',newValue);
    }
  }
